var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-theme-provider',{attrs:{"dark":_vm.theme === _vm.themeNames.DARK,"light":_vm.theme === _vm.themeNames.LIGHT}},[_c(_vm.tag,{tag:"component",class:{
      [`gfilm-theme-provider theme--${_vm.theme}`]: true,
      'fill-background': _vm.fillBackground,
    },style:(_vm.style)},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }